'use client';

import { useEffect } from 'react';
import { reportClientError } from '@/lib/report-client-error';

// Scoped to the (trading) route group. Renders INSIDE (trading)/layout.tsx,
// so the layout's `useEffect(() => connectExec())` keeps the executor
// WebSocket alive — only the page body is swapped for this fallback. A
// render crash here no longer tears down the socket or white-screens the
// whole app.
export default function TradingError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}): JSX.Element {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error('trading route error', error);
    reportClientError(error);
  }, [error]);
  return (
    <section className="m-4 border border-border rounded-lg bg-panel p-6 text-sm">
      <h2 className="text-base font-semibold text-err">Something went wrong</h2>
      <p className="mt-2 text-muted">
        This view hit an error. The market connection is still live — try again.
      </p>
      {error.digest ? (
        <p className="mt-2 text-[10px] text-muted">Error ID: {error.digest}</p>
      ) : null}
      <button
        onClick={reset}
        className="mt-4 rounded-md border border-accent px-3 py-1 text-xs text-accent hover:bg-accent/10"
      >
        Try again
      </button>
    </section>
  );
}
